<!-- src/app/shared/components/productos/productos.component.html -->
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Playeras"></mat-tab>
  <mat-tab label="Gorras"></mat-tab>
</mat-tab-group>

<div style="display: flex; flex-wrap: wrap; gap: 1rem; margin-top: 1rem;">
  <mat-card *ngFor="let producto of productosFiltrados" style="width: 250px;">
    <img mat-card-image [src]="producto.imagen" [alt]="producto.nombre" />
    <mat-card-title>{{ producto.nombre }}</mat-card-title>
    <mat-card-content>
      <p>{{ producto.descripcion }}</p>
      <p><strong>{{ producto.precio }}</strong></p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="comprarProducto(producto)">Comprar</button>
    </mat-card-actions>
  </mat-card>
</div>
